import script from "./UserForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserForm.vue?vue&type=script&lang=ts&setup=true"

import "./UserForm.vue?vue&type=style&index=0&id=7cc5e908&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/webapp/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7cc5e908"]])

export default __exports__